export default __webpack_public_path__ + "static/media/intro-pic.f15f1755.jpg";